export const downloadReportClicked = {
    event: "download_report_clicked",
    eventCategory: "service_homepage",
    eventAction: "download_report_clicked"
};
